module.exports = __webpack_public_path__ + "static/media/vf-logo.33d76cad.svg";